<script setup lang='ts'>
import { useClass } from "~/composables/local/cn-class"

type MarqueeProps = {
	class?: string
	reverse?: boolean
	pauseOnHover?: boolean
	vertical?: boolean
	repeat?: number
	[key: string]: any
}

const props = withDefaults(defineProps<MarqueeProps>(), {
	pauseOnHover: false,
	vertical: false,
	repeat: 4,
})

const repeatArray = computed(() => Array.from<number>({ length: props.repeat }).fill(0))

const itemClass = useClass(
	"inline-flex shrink-0 justify-around [gap:var(--gap)]",
	{
		"marquee-vertical flex-col": props.vertical,
		"marquee flex-row": !props.vertical,
		"![animation-direction:reverse]": props.reverse,
		"group-hover:[animation-play-state:paused]": props.pauseOnHover,
	},
)

const rootClass = useClass(
	"group inline-flex overflow-hidden p-2 [--duration:40s] [--gap:1rem] [gap:var(--gap)]",
	{
		"flex-row": !props.vertical,
		"flex-col": props.vertical,
	},
	() => props.class,
)
</script>

<template>
	<div
		v-bind="props"
		:class="rootClass">
		<div
			v-for="i in repeatArray"
			:key="i">
			<div :class="itemClass">
				<slot />
			</div>
		</div>
	</div>
</template>

<style lang="css" scoped>
:root {
	--duration: 5s;
	--gap: 20px;
}

@keyframes marquee {
	from {
		transform: translateX(0);
	}

	to {
		transform: translateX(calc(-100% - var(--gap)));
	}
}

@keyframes marquee-vertical {
	from {
		transform: translateY(0);
	}

	to {
		transform: translateY(calc(-100% - var(--gap)));
	}
}

.marquee {
	animation: marquee var(--duration) linear infinite;
}

.marquee-vertical {
	animation: marquee-vertical var(--duration) linear infinite;
}
</style>
